/* eslint-disable no-magic-numbers */
import * as Adaptive from 'adaptivecards';

export class RecommendationInput extends Adaptive.Input {
	static labelProperty = new Adaptive.StringProperty(Adaptive.Versions.v1_6, 'label');
	static valueProperty = new Adaptive.StringProperty(Adaptive.Versions.v1_6, 'value');

	constructor() {
		super();
		// Use the input's id property if available, else fallback to random id.
		this.baseId = this.id
			? `recommendation-${this.id}`
			: `recommendation-${Math.random().toString(36).slice(2, 9)}`;
	}

	get label() {
		return this.getValue(RecommendationInput.labelProperty);
	}

	set label(value) {
		if (this.label !== value) {
			this.setValue(RecommendationInput.labelProperty, value);
			this.updateLayout();
		}
	}

	get value() {
		return this.getValue(RecommendationInput.valueProperty);
	}

	set value(value) {
		if (this.value !== value) {
			this.setValue(RecommendationInput.valueProperty, value);
			this.updateLayout();
		}
	}

	isSet() {
		return Boolean(this.value);
	}

	createRecommendationButton(value, ariaLabel, svgContent) {
		const button = document.createElement('button');
		button.id = `${this.baseId}-button-${value}`;
		button.innerHTML = svgContent;
		button.style.width = '35px';
		button.style.height = '35px';
		button.style.backgroundColor = 'transparent';
		button.style.border = '0';
		button.style.fontSize = '25px';
		button.style.color = '#000';
		button.style.cursor = 'pointer';
		button.setAttribute('role', 'radio');
		button.setAttribute('aria-checked', 'false');
		button.setAttribute('aria-label', ariaLabel);
		button.setAttribute('tabindex', '0');
		button.onclick = () => {
			this.setValue(RecommendationInput.valueProperty, value);
			this.refreshRecommendationElements(value);
			this.valueChanged();
		};
		return button;
	}

	internalRender() {
		const labelBlock = new Adaptive.TextBlock();
		labelBlock.setParent(this);
		labelBlock.hostConfig = this.hostConfig;
		labelBlock.text = !this.label ? 'untitled' : this.label;
		labelBlock.wrap = this.wrap;
		this.labelElement = labelBlock.render();
		this.labelElement.id = `${this.baseId}-label`;

		const element = document.createElement('div');
		element.setAttribute('role', 'radiogroup');
		element.setAttribute('aria-labelledby', this.labelElement.id);
		this.recommendationElements = {};

		// Thumbs Up Button
		const thumbsUpSvg = `
            <svg
                width="24px"
                height="24px"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7 0L5 5V14H14L16 8V5H10V2C10 0.895431 9.10457 0 8 0H7Z"
                    fill="#000000"
                />
                <path d="M3 5H0V14H3V5Z" fill="#000000" />
            </svg>
        `;
		this.recommendationElements['2'] = this.createRecommendationButton(2, 'Thumbs up', thumbsUpSvg);
		element.append(this.recommendationElements['2']);

		// Thumbs Down Button
		const thumbsDownSvg = `
            <svg
                width="24px"
                height="24px"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="transform: rotate(180deg)"
            >
                <path
                    d="M7 0L5 5V14H14L16 8V5H10V2C10 0.895431 9.10457 0 8 0H7Z"
                    fill="#000000"
                />
                <path d="M3 5H0V14H3V5Z" fill="#000000" />
            </svg>
        `;
		this.recommendationElements['0'] = this.createRecommendationButton(
			0,
			'Thumbs down',
			thumbsDownSvg,
		);
		element.append(this.recommendationElements['0']);

		this.recommendationElements['2'].classList.add('ac-input-container');
		this.recommendationElements['2'].ariaRequired = 'true';
		this.labelElement.forElementId = this.recommendationElements['2'].id;

		// Ensure initial colors are set
		this.refreshRecommendationElements();

		return element;
	}

	getJsonTypeName() {
		return 'Input.Recommendation';
	}

	parse(json, errors) {
		super.parse(json, errors);
		this.label = json.label;
		this.value = json.value;
	}

	refreshRecommendationElements() {
		for (const [key, element] of Object.entries(this.recommendationElements)) {
			const svg = element.querySelectorAll('svg path');
			const isSelected = key === String(this.value);
			svg.forEach((path) => path.setAttribute('fill', isSelected ? 'rgb(250, 175, 0)' : '#959393'));
			element.setAttribute('aria-checked', isSelected ? 'true' : 'false');
		}
	}

	updateLayout(processChildren = true) {
		super.updateLayout(processChildren);
		if (this.renderedElement) {
			this.refreshRecommendationElements(this.value);
		}
	}

	renderSpeech() {
		return this.value === 2 ? 'Thumbs up selected' : 'Thumbs down selected';
	}
}
